import { Phone, MessageCircle, Mail, MapPin, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getWhatsAppUrl } from '@/lib/whatsapp';

const contactInfo = [
  { icon: Phone, label: 'Phone', value: '+91 96792 00493', href: 'tel:+919679200493' },
  { icon: MessageCircle, label: 'WhatsApp', value: '+91 96792 00493', href: getWhatsAppUrl('Hi! I have a query.') },
  { icon: Mail, label: 'Email', value: 'chinmaydebnath21@gmail.com', href: 'mailto:chinmaydebnath21@gmail.com' },
  { icon: MapPin, label: 'Address', value: 'Kharagpur City Road, Baga Bhera, West Bengal, Pin 721437, India', href: 'https://maps.google.com/?q=Kharagpur+City+Road+Baga+Bhera+West+Bengal+721437' },
  { icon: Clock, label: 'Hours', value: 'Mon–Sat: 9AM – 9PM, Sun: 10AM – 6PM', href: undefined },
];

const ContactPage = () => (
  <div>
    <div className="bg-gradient-to-br from-primary to-navy-dark text-primary-foreground py-16 text-center">
      <h1 className="font-heading text-3xl md:text-4xl font-extrabold mb-3">Contact Us</h1>
      <p className="opacity-80">We'd love to hear from you</p>
    </div>

    <div className="container section-padding">
      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        <div className="space-y-4">
          <h2 className="font-heading text-xl font-bold mb-4">Get in Touch</h2>
          {contactInfo.map(c => (
            <div key={c.label} className="flex items-start gap-4 p-4 bg-card border rounded-lg">
              <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center shrink-0">
                <c.icon className="h-5 w-5 text-primary" />
              </div>
              <div>
                <p className="font-heading font-semibold text-sm">{c.label}</p>
                {c.href ? (
                  <a href={c.href} target="_blank" rel="noopener noreferrer" className="text-sm text-accent hover:underline">
                    {c.value}
                  </a>
                ) : (
                  <p className="text-sm text-muted-foreground">{c.value}</p>
                )}
              </div>
            </div>
          ))}

          <a href={getWhatsAppUrl('Hi! I have a question about your products.')} target="_blank" rel="noopener noreferrer">
            <Button size="lg" className="w-full mt-4 gap-2 bg-success hover:bg-success/90 text-primary-foreground font-heading font-semibold">
              <MessageCircle className="h-5 w-5" /> Send WhatsApp Enquiry
            </Button>
          </a>
        </div>

        <div id="map" className="rounded-xl overflow-hidden border h-80 md:h-full min-h-[320px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.5!2d88.35!3d22.57!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDM0JzEyLjAiTiA4OMKwMjEnMDAuMCJF!5e0!3m2!1sen!2sin!4v1"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Store Location"
          />
        </div>
      </div>
    </div>
  </div>
);

export default ContactPage;
